import CategoriesBtnColor from "../../js/categoriesBtnData";
import Icons from "../../assets/icon";
import localimgpath from "../../js/localimgpath";
import TheATeamColorsData from "../../js/theATeamData";

import {
  Footer,
  Experience,
  MainHeading,
  Navbar,
  HoverButton,
  Animatespin,
  CategoriesBtnCom,
  TheATeamCom,
} from "../../components";
import Functions from "./index.function";
const Team = () => {
  const {
    setAllcategories,
    handleButtonClick,
    handleTeamId,
    setSeteledcategories,
    allcategories,
    categoriesTtypesNewsId,
    TheATeamData,
    CategoriesTypesTeams,
    additionalTeams,
    newsDataisLoading,
    jobHasMorePages,
    setAllTeamsCurrentPage,
    seteledcategories,
    isLoading,
    singleCatTeamData,
  } = Functions();
  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:py-5">
        <MainHeading
          title={"Team"}
          dis={" "}
          layout={"h-18 sm:h-20 lg:h-36"}
          navigate={"/"}
        />
        <div className="overflow-x-auto dashboard-scrollbar-cat xs:pt-2 px-1 xs:pb-2 sm:pb-4">
          <div className="flex xs:gap-x-2 sm:gap-x-3 items-center justify-center mx-auto w-max">
            <div
              onClick={() => {
                setAllcategories(true);
                setSeteledcategories(false);
              }}
            >
              <CategoriesBtnCom
                btnTitle={"All"}
                bgColor={"#FA5738"}
                btnIcon={Icons.directorChairIcon}
                CateclassName={
                  "cursor-pointer xs:rounded-md sm:rounded-lg xs:px-4 xs:py-2 sm:py-3 xs:gap-x-1 sm:px-5 sm:gap-x-2 relative flex items-center justify-center overflow-hidden text-secondary transition-all shadow-md before:absolute before:h-0 before:w-0 before:rounded-full before:bg-orange-600 hover:shadow-orange-600 before:duration-500 before:ease-out hover:before:h-56 lg:hover:before:w-72 2xl:hover:before:w-80 3xl:hover:before:w-96 sm:hover:before:w-64"
                }
                fontClassname={"font-onestSemiBold"}
                iconlayout={"xs:w-4 sm:w-5 lg:w-5"}
                alt={"All"}
              />
            </div>
            <div className="grid grid-flow-col auto-cols-max gap-x-3">
              {CategoriesTypesTeams?.categories.map((value, index) => (
                <CategoriesBtnCom
                  key={index}
                  onClick={() => handleButtonClick(value?.id)}
                  btnTitle={value.title}
                  bgColor={
                    allcategories
                      ? CategoriesBtnColor[
                          (index + 1) % CategoriesBtnColor.length
                        ].bgColor
                      : categoriesTtypesNewsId === value?.id
                      ? CategoriesBtnColor[
                          (index + 1) % CategoriesBtnColor.length
                        ].activeBgColor
                      : CategoriesBtnColor[
                          (index + 1) % CategoriesBtnColor.length
                        ].bgColor
                  }
                  btnIcon={
                    value?.icon
                      ? `${localimgpath?.categoryIcons}/${value?.icon}`
                      : Icons.directorChairIcon
                  }
                  CateclassName={
                    "cursor-pointer xs:rounded-md sm:rounded-lg xs:px-4 xs:py-2 sm:py-3 xs:gap-x-1 sm:px-5 sm:gap-x-2 relative flex items-center justify-center overflow-hidden text-secondary transition-all shadow-md before:absolute before:h-0 before:w-0 before:rounded-full before:bg-orange-600 hover:shadow-orange-600 before:duration-500 before:ease-out hover:before:h-56 lg:hover:before:w-72 2xl:hover:before:w-80 3xl:hover:before:w-96 sm:hover:before:w-64"
                  }
                  fontClassname={"font-onestSemiBold"}
                  iconlayout={"xs:w-4 sm:w-5 lg:w-5"}
                  alt={value?.title}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 flex lg:pt-14 flex-wrap xs:pt-5 xs:gap-x-2 xs:gap-y-3 sm:gap-3 sm:justify-center sm:py-6 lg:gap-8 xs:justify-center lg:justify-center">
          {TheATeamData?.teams?.length < 1 ? (
            <p className="text-secondary font-onestLight xs:text-xs sm:text-xs lg:text-sm text-center w-full sm:pt-6 pt-3">
              Data not available
            </p>
          ) : (
            <>
              {allcategories &&
                additionalTeams?.map((slide, index) => (
                  <div key={`${index}`}>
                    <TheATeamCom
                      onClick={() =>
                        handleTeamId(
                          slide?.id,
                          TheATeamColorsData[index % TheATeamColorsData.length]
                            .bgcolor
                        )
                      }
                      image={`${localimgpath.teamAvatar}/${slide?.avatar}`}
                      title={slide?.name}
                      hoverlayout={
                        "transition-all duration-300 transform hover:scale-105 hover:shadow-md"
                      }
                      bgcolor={
                        TheATeamColorsData[index % TheATeamColorsData.length]
                          .bgcolor
                      }
                      position={slide?.designation?.name}
                      location={`${slide?.city?.city}. ${slide?.country?.country}`}
                    />
                  </div>
                ))}
              {newsDataisLoading ? (
                <div className="xs:pt-1 sm:pt-2 lg:pt-3">
                  <Animatespin />
                </div>
              ) : (
                <>
                  {allcategories ? (
                    <>
                      {jobHasMorePages && (
                        <div
                          className={`flex justify-center items-center xs:pt-5 sm:pt-5 lg:pt-10`}
                        >
                          <HoverButton
                            onClick={() =>
                              setAllTeamsCurrentPage((prev) => prev + 1)
                            }
                            extraClasses={
                              "group xs:w-56 xs:h-8 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                            }
                            BtnTitle={"Load More News"}
                            BtnTitleClasses={
                              "text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
                            }
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </>
              )}
            </>
          )}
          {seteledcategories && (
            <>
              {isLoading ? (
                <div className="sm:py-2 py-1">
                  <Animatespin />
                </div>
              ) : (
                <>
                  {singleCatTeamData?.teams?.length < 1 ? (
                    <p className="text-secondary font-onestLight xs:text-xs sm:text-xs lg:text-sm text-center w-full sm:pt-6 pt-3">
                      Data not available
                    </p>
                  ) : (
                    singleCatTeamData?.teams &&
                    singleCatTeamData?.teams?.map((slide, index) => (
                      <div key={`${index}`}>
                        <TheATeamCom
                          onClick={() =>
                            handleTeamId(
                              slide?.id,
                              TheATeamColorsData[
                                index % TheATeamColorsData.length
                              ].bgcolor
                            )
                          }
                          image={`${localimgpath.teamAvatar}/${slide?.avatar}`}
                          title={slide?.name}
                          hoverlayout={
                            "transition-all duration-300 transform hover:scale-105 hover:shadow-md"
                          }
                          bgcolor={
                            TheATeamColorsData[
                              index % TheATeamColorsData.length
                            ].bgcolor
                          }
                          position={slide?.designation}
                          location={`${slide?.city?.city}. ${slide?.country?.country}`}
                        />
                      </div>
                    ))
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
      <div className="xs:pt-4">
        <Experience />
      </div>
      <Footer />
    </div>
  );
};

export default Team;
